module.exports = __webpack_public_path__ + "img/webplugincheck.8106478.svg";